import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from "react-router-dom"; 
import '../css sheets/navbar.css'
import 'bootstrap/dist/css/bootstrap.min.css';



function Navigation() {
  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="custom-navbar">
        <Container>
  
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='navbar-collapsed'>
            <Nav className="me-auto mx-auto">
              <img src="AT_logo.png" className="App-logo"></img>
              <Link to="/" className='custom-navbar-link'>Home</Link>
              <Link to="/portfolio" className='custom-navbar-link'>Portfolio</Link>
              <Link to="/about" className='custom-navbar-link'>About Me</Link>
              <Link to="/resume" className='custom-navbar-link'>Resume</Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Navigation;